// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__FsYV0","lastUpdated":"TermsOfService_lastUpdated__1Y6TV","line":"TermsOfService_line__29k6m"};